export default __webpack_public_path__ + "static/media/AFTIM-img-1.aa90ae98.jpg";